import Accordion from '../Accordion/Accordion';
import { ContentContainer } from '../ContentContainer/ContentContainer';
import { Headline } from '../Headline/Headline';
import styles from './Faq.module.scss';

const faqs = [
  {
    headline:
      'Welche Ladestationen kann ich mit der enercity easyGo App nutzen?',
    description:
      'Sie können mit der enercity easyGo App an allen Ladestationen von enercity laden und die Ladestationen unserer Partner nutzen. So haben Sie Zugriff auf ein deutschlandweites Netz aus rund 150.000 Ladepunkten.',
  },

  {
    headline: 'Was kostet die enercity easyGo App?',
    description: (
      <>
        <p>
          Die enercity easyGo App ist für Sie kostenlos! Eine Grundgebühr gibt
          es nicht. Die Preise für das Laden werden Ihnen an den Ladepunkten und
          vor dem Start eines Ladevorgangs angezeigt.
        </p>
        <p>
          <strong>enercity easyGo FixLaden</strong>
          <br /> Sie laden an allen enercity-Ladestationen zu festen kWh-Preisen.
          Derzeit sind das für AC 0,45 €/kWh und DC 0,55 €/kWh. Ab 01.08.2025
          passen wir die Preise an: AC 0,47 €/kWh und DC 0,57 €/kWh. Ganz ohne
          Grundgebühr! Die Preise für das Laden an den Stationen unserer
          Partner:innen finden Sie transparent in unserer App.
        </p>
        <p>
          <strong>enercity easyGo SmartLaden</strong>
          <br />
          Mit einer monatlichen Grundgebühr von 5,99 € laden Sie zu reduzierten
          kWh-Preisen: AC 0,42 €/kWh und DC 0,52 €/kWh. Die Preise für das Laden
          an den Stationen unserer Partner:innen finden Sie transparent in
          unserer App.
        </p>
      </>
    ),
  },

  {
    headline:
      'Wie finde ich eine öffentliche Ladestation über die enercity easyGo App?',
    description:
      'In der enercity easyGo App finden Sie in der Kartenansicht den Punkt „Ladepunkt finden“. Geben Sie dort den gewünschten Ort ein. Anschließend werden die Ladepunkte in Ihrer Umgebung angezeigt. Übrigens: Zusätzlich können Sie die Ladepunkt-Suche individuell anpassen (zum Beispiel nach Ihrem hinterlegten Fahrzeug, Verfügbarkeit oder Ladestationsbetreiber).',
  },

  {
    headline: 'Wie starte ich einen Ladevorgang mit der enercity easyGo App?',
    description:
      'Über die Kartenansicht wählen Sie eine Ladestation aus. Hat die Ladestation mehrere Ladepunkte wählen Sie bitte den gewünschten Ladepunkt aus und klicken auf „Laden Sie hier“. Im nächsten Schritt werden noch einmal transparent die Preise angezeigt (pro kWh und pro Minute). Zum Starten des Ladevorgangs wischen Sie an ihrem unteren Bildschirm von links nach rechts.',
  },

  {
    headline: 'Wo kann ich zukünftig eine Ladekarte bestellen?',
    description:
      'Eine Ladekarte können Sie komfortabel in der enercity easyGo App bestellen. Einfach die App installieren und im Menü „Ladekarten“ eine Ladekarte anfordern.',
  },

  {
    headline: 'Wie werden die Ladevorgänge abgerechnet?',
    description:
      'Die Ladevorgänge werden monatlich abgebucht. Aktuell bieten wir die Bezahlung per SEPA-Lastschrift und Kreditkarte an. Die Rechnungen senden wir Ihnen monatlich zu. Zusätzlich sind die erfolgten Ladevorgänge und entstanden Kosten jederzeit in der Ladehistorie der easyGo App abrufbar.',
  },

  {
    headline: 'Welche Zahlungsmittel kann ich in der App nutzen?',
    description: 'SEPA-Lastschrift und Kreditkarte',
  },

  {
    headline: 'Gibt es eine Übersicht über meine abgeschlossenen Ladevorgänge?',
    description:
      'Ja, in der Ladehistorie finden Sie einen kompletten Überblick über alle abgeschlossenen Ladevorgänge. Aus allen Ladevorgängen in einem Abrechnungszeitraum wird eine Rechnung erstellt, die wir Ihnen per E-Mail monatlich zusenden.',
  },
  {
    headline:
      'Kann ich das easyGo-Angebot und die App auch für mein Unternehmen nutzen?',
    description: (
      <p>
        Ja, mit easyGo können Sie auch mit Ihrem Unternehmen die
        deutschlandweiten Lademöglichkeiten nutzen. Sie profitieren von den
        attraktiven Preisen an unseren enercity Ladestationen. Nutzen Sie gerne
        den folgenden{' '}
        <a
          href="https://portal.epilot.cloud/journey-app/?journeyId=07eb7cd0-ba1f-11ee-91e5-df0d29f3a9a8"
          target="_blank"
          rel="noreferrer"
        >
          Link
        </a>
        , um uns alle notwendigen Informationen mitzuteilen. Dann kann es für
        Ihr Unternehmen schon in Kürze mit easyGo losgehen.
      </p>
    ),
  },
  {
    headline: 'Wo finde ich die enercity easyGo AGBs?',
    description: (
      <p>
        Die enercity easyGo AGBs finden Sie in der enercity easyGo App.
        Zusätzlich können Sie sich diese hier herunterladen:{' '}
        <a
          href="https://www.enercity.de/assets/cms/enercity-de/Privatkunden/Produkte/Elektromobilitaet/easygo/agb-geschaeftskunden-easygo.pdf"
          target="_blank"
          download
        >
          Link
        </a>
      </p>
    ),
  },

  {
    headline: 'Wie kann ich den Tarif easyGo SmartLaden abschließen?',
    description:
      'In der easyGo App befindet sich im Menü der Reiter „Abonnements". Hier wird der easyGo SmartLaden-Tarif angezeigt und kann ausgewählt sowie abgeschlossen werden.',
  },

  {
    headline: 'Wie lange ist die Vertragslaufzeit?',
    description: 'Der Tarif enercity easyGo SmartLaden ist monatlich kündbar.',
  },

  {
    headline:
      'Wie kann ich den Tarif easy Go SmartLaden kündigen? Und in welchen Tarif komme ich dann?',
    description:
      'In der easyGo App befindet sich im Menü der Reiter "Abonnements". Hier wird der derzeit aktive Tarif angezeigt und kann ausgewählt sowie gekündigt werden. Nach der Kündigung des Tarifs easyGo SmartLaden gilt der Tarif easyGo FixLaden.',
  },

  {
    headline: 'Was sind die Vorteile des Abo-Modells?',
    description: (
      <>
        <p>Sie haben folgende Vorteile:</p>
        <p>
          <strong>Flexible Laufzeit:</strong>
          <br /> Sie können den Tarif ganz einfach monatlich kündigen
        </p>
        <p>
          <strong>Attraktive Konditionen:</strong>
          <br />
          Sie laden zu besonders günstigen kWh-Preisen
        </p>
        <p>
          <strong>Weitere spannende Features ab Herbst 2025:</strong>
          <br />
          In Zukunft können Sie ihren Ladevorgang intelligent steuern und
          profitieren zeitweise von noch günstigeren Preisen.
        </p>
        <p>
          Übrigens: bereits ab einer jährlichen Fahrleistung von 650 km pro
          Monat ist der Tarif easyGo SmartLaden für Sie die beste Wahl!
        </p>
      </>
    ),
  },
];

export const Faq = () => {
  return (
    <div className={styles.base}>
      <ContentContainer size={'s'}>
        <Headline className={styles.title} color="gradient">
          Häufig gestellte Fragen
        </Headline>

        <Accordion items={faqs} />
      </ContentContainer>
    </div>
  );
};
